export const DATABASES = [
    { key: 'zmuek_companies', label: 'companies' },
    { key: 'zmuek_users', label: 'users' },
    { key: 'zmuek_products', label: 'products' },
    { key: 'zmuek_jobs', label: 'jobs' },
    { key: 'zmuek_files', label: 'files' },
    { key: 'zmuek_addresses', label: 'addresses' },
    { key: 'zmuek_qs', label: 'qs' },
]
